import { RawContextKey } from '../../../../platform/contextkey/common/contextkey.js';
var IOutlinePane;
( (function(IOutlinePane) {
    IOutlinePane.Id = 'outline';
})(IOutlinePane || (IOutlinePane = {})));
const ctxFollowsCursor = ( new RawContextKey('outlineFollowsCursor', false));
const ctxFilterOnType = ( new RawContextKey('outlineFiltersOnType', false));
const ctxSortMode = ( new RawContextKey('outlineSortMode', 0 ));
const ctxAllCollapsed = ( new RawContextKey('outlineAllCollapsed', false));
export { IOutlinePane, ctxAllCollapsed, ctxFilterOnType, ctxFollowsCursor, ctxSortMode };
